/** @format */

import ButtonCircleStyles from "./Button.module.scss";
import Loading from "../Loading/Loading";

const ButtonCircle = ({
    buttonText,
    color = "#fff",
    gray = false,
    pink = false,
    white = false,
    disable = false,
    fontSize = "16px",
    height = 50,
    width = "100%",
	isLoading = false,
    onClick = () => {},
    ...props
}) => {
    let backgroundButton =
        "linear-gradient(83.47deg, #58cc02 9.02%, #23ac38 90.81%)";
    let backgroundButtonSide = "#209b32";

    if (gray) {
        backgroundButton = "#e0e0e0";
        backgroundButtonSide = "#d0cccb";
    }

    if (white) {
        backgroundButton = "#fff";
        backgroundButtonSide = "rgba(0,0,0,0.1)";
    }

    if (pink) {
        backgroundButton = "#eb5757";
        backgroundButtonSide = "#e0e0e0";
    }

    if (disable) {
        backgroundButton = "#e0e0e0";
        backgroundButtonSide = "none";
    }

    return (
        <div
            className={ButtonCircleStyles.wrapper}
            style={{
                width: "100%",
                height: height,
                borderRadius: height / 2,
                background: backgroundButtonSide,
            }}>
            <div
                className={`${ButtonCircleStyles.button} ${
                    disable && ButtonCircleStyles.button_disable
                }`}
                style={{
                    fontSize: fontSize,
                    width: "100%",
                    height: height,
                    color: gray && "#212529",
                    borderRadius: height / 2,
                    color: color,
                    background: backgroundButton,
                    // border: white && "1px solid #E0E0E0",
                }}
                onClick={onClick}
                {...props}>
                { !isLoading ? buttonText : <Loading/>}
            </div>
        </div>
    );
};
export default ButtonCircle;
